export default __webpack_public_path__ + "static/media/time.4ae5ba02.svg";